import { apiRequest } from '@/utils/api-request';
import { Eval, CreateEvalRequest } from '@/types/evals-types';
import { useOrgStore } from '@/stores/org-store';

export const createEvaluation = async (
  body: CreateEvalRequest,
): Promise<Eval> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  const response = await apiRequest<Eval>({
    url: `/evaluations/${orgId}`,
    target: 'platform',
    method: 'POST',
    body: body as unknown as Record<string, unknown>,
  });
  if (response.success === false) {
    throw new Error(response.detail);
  }
  return response?.data as Eval;
};
